export default [
  {
    header: 'TEA',
    resource: 'trabajaenagrovision',
    action: 'menu',
  },
  {
    title: 'Registros TEA',
    route: 'trabajaenagrovision',
    icon: 'UsersIcon',
    action: 'menu',
    resource: 'trabajaenagrovision'
  },
  {
    title: 'Registros TEA Movil',
    route: 'trabajaenagrovisionmovil',
    icon: 'UsersIcon',
    action: 'menu',
    resource: 'trabajaenagrovisionmovil'
  },
  {
    title: 'Usuarios TEA',
    route: 'trabajaenagrovisionusuarios',
    icon: 'UsersIcon',
    action: 'menu',
    resource: 'trabajaenagrovisionusuarios'
  },
  {
    title: 'Registro Ausentismos',
    route: 'trabajaenagrovisionreclutamiento',
    icon: 'UsersIcon',
    action: 'menu',
    resource: 'trabajaenagrovisionreclutamiento'
  },
]
